var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"job__favourite fa",class:{
    'fa-star': _vm.currentState,
    'fa-star-o': ! _vm.currentState
},on:{"click":function($event){return _vm.toggleFavourite()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }